@if (isLoading$ | async) {
  <app-square-loader
    size="65"
  ></app-square-loader>
}
@if (isFailed$ | async) {
  <div class="alert-box">
    {{ 'COMMON.ERROR' | translate }}
  </div>
}
<div
  #turnstileContainer
  [class.d-none]="isLoading$ | async"
  >
</div>
